import React from "react";
import DialogContentText from "@mui/material/DialogContentText";
import styled from "@emotion/styled";

export default function About() {
  return (
    <DialogContentText>
      We have created this app because we like to travel without too much
      planning ahead. All travelling information is provided by Wikivoyage. If
      you find the information helpful, consider to support them by contributing
      or donate to the wikimedia foundation <p />
      Links:
      <br />
      <a
        href="https://www.wikivoyage.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AboutLinks>www.wikivoyage.org</AboutLinks>
      </a>
      <br />
      <a
        href="https://wikimediafoundation.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AboutLinks>www.wikimediafoundation.org</AboutLinks>
      </a>
      <p />
      For feedback:
      <br />
      contact option coming soon.
      <p />
      Ganna and Heng from Hamburg, Germany
      <p />
      <HorizontalLine />
      Data privacy: We access the device GPS to locate you on the map. We do not save the location data. We save account data to enable user related functions. Hoewever, person related information are not required.
    </DialogContentText>
  );
}

const AboutLinks = styled.div`
  display: inline-block;
  color: #4495cf;
  text-decoration: none;
  font-family: Arial, sans-serif;
`;


const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin: 16px 0;
`;
